<template>
  <div class="grid grid-cols-12 gap-0 bg-gray-100 dark:bg-gray-800 font-medium text-gray-700 dark:text-gray-300 text-sm border-b border-gray-200 dark:border-gray-700">
    <div class="col-span-4 py-1 px-2 border-r border-gray-200 dark:border-gray-700">Operation</div>
    <div class="col-span-2 py-1 px-2 text-center border-r border-gray-200 dark:border-gray-700">Status</div>
    <div class="col-span-1 py-1 px-2 text-center border-r border-gray-200 dark:border-gray-700">Hours</div>
    <div class="col-span-1 py-1 px-2 text-center border-r border-gray-200 dark:border-gray-700">Charged</div>
    <div class="col-span-1 py-1 px-2 text-center border-r border-gray-200 dark:border-gray-700">Actual</div>
    <div class="col-span-1 py-1 px-2 text-center border-r border-gray-200 dark:border-gray-700">Quote</div>
    <div class="col-span-1 py-1 px-2 text-center">Actions</div>
  </div>
</template>
